/** Fixed-timestep simulation with variable-rate rendering. */
export const STEP = 1 / 60;

export function startLoop(update: (dt: number) => void, render: (alpha: number) => void): () => void {
  let last = performance.now();
  let acc = 0;
  let running = true;
  function frame(now: number) {
    if (!running) return;
    let dt = (now - last) / 1000;
    last = now;
    if (dt > 0.25) dt = 0.25; // tab was hidden; don't spiral
    acc += dt;
    let steps = 0;
    while (acc >= STEP && steps < 5) {
      update(STEP);
      acc -= STEP;
      steps++;
    }
    if (steps === 5) acc = 0;
    render(acc / STEP);
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
  return () => {
    running = false;
  };
}
